/* @ngInject */
export default function PartNumberFormatterService() {
    /**
     * Format the part number and remove curly suffix
     * @param pn
     */
    function formatPartNumber(pn) {
        if (pn === undefined) {
            return pn;
        } else {
            return pn.replace(/({[^;]*})/gi, '');
        }
    }

    return {
        formatPn: formatPartNumber,
        /**
         * Format the part number inside the alias
         *
         * @param obj
         * @returns {*}
         */
        formatAliasValue: function (obj) {
            obj.value = formatPartNumber(obj.value);
            return obj;
        }
    };
}
